// Module
var code = "<nav3-menu> <nav3-menu-col> <nav3-menu-item id=\"discover-nav-dropdown-item\" text=\"Discover\" state=\"influencers\"></nav3-menu-item> <nav3-menu-item id=\"community-nav-dropdown-item\" text=\"Community\" state=\"community\"></nav3-menu-item> </nav3-menu-col> </nav3-menu> ";
// Exports
module.exports = code;